import React from "react";
import { UserInterface } from "src/store/community/usersSlice";
import Card from "src/componets/Card";
import Posts from "./_Posts";

const _Details = ({ user }: { user: UserInterface | undefined }) => {
  if (!user) {
    return null;
  }

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>About me</h4>

        {user?.about_me}
      </Card>

      <Posts userId={user?.id} />
    </>
  );
}

export default _Details;
